/* eslint-disable react/prop-types */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { handleDeletePage } from '../../PaginasServices';
import { Container } from './styles';

function UpdateCard({ pageData, loading, handleSubmit, setForm, form }) {
  const history = useHistory();
  return (
    <Container>
      <h1>Atualizar dados da página: {pageData.nome}</h1>
      <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <FormGroup>
          <Label>Nome da página</Label>
          <Input
            name="nome"
            id="nome"
            type="text"
            placeholder={pageData.nome}
            onChange={(e) => {
              setForm({ ...form, nome: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>
            Situação cadastral:
            <strong>
              {pageData.idSituacaoCadastral === 1 ? 'Ativo' : 'Inativo'}
            </strong>
          </Label>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => setForm({ ...form, idSituacaoCadastral: 1 })}
              />
              Ativo
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => setForm({ ...form, idSituacaoCadastral: 3 })}
              />
              Inativo
            </Label>
          </FormGroup>
        </FormGroup>
        {loading ? (
          <section>
            <Button color="primary" disabled>
              <Spinner color="light" size="sm" />
            </Button>
            <Button color="danger" outline disabled>
              <Spinner color="light" size="sm" />
            </Button>
          </section>
        ) : (
          <section>
            <Button color="primary" onClick={handleSubmit} className="btn2">
              Atualizar
            </Button>
            <Button
              outline
              color="danger"
              onClick={() => {
                handleDeletePage();
                history.push('/page/list');
              }}
              className="btn1"
            >
              Excluir
            </Button>
          </section>
        )}
      </Form>
    </Container>
  );
}

export default UpdateCard;
